var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-background",attrs:{"id":"home"}},[_c('router-link',{attrs:{"to":{ name: 'my-work' },"id":"enter"}},[_vm._v("ENTER")]),_c('div',{attrs:{"id":"fade-overlay"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }